module.exports = __webpack_public_path__ + "img/events.bdb7031f.svg";